import { render, staticRenderFns } from "./add-on-item.vue?vue&type=template&id=4ee006bd&"
import script from "./add-on-item.vue?vue&type=script&lang=js&"
export * from "./add-on-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports